import * as React from "react";
import styled from "styled-components";
import { Button } from "components/bootstrap";
import { Icon } from "components/common";
const StyledButton = styled(Button)`
  padding: 6px 10px;
`;
const TimeRangePickerButton = ({ hasError = false, disabled = false, onClick = void 0 }) => /* @__PURE__ */ React.createElement(
  StyledButton,
  {
    bsStyle: hasError ? "danger" : "info",
    disabled,
    onClick,
    "aria-label": "Open Time Range Selector"
  },
  /* @__PURE__ */ React.createElement(Icon, { name: hasError ? "warning" : "schedule" })
);
export default TimeRangePickerButton;
